import React from 'react';

import profileImage from '../../../../../../assets/images/patients/profile.svg?url';
import styles from './index.module.scss';

const SkipSentSmsView = () => {
  return (
    <div className="flex flex-col gap-12">
      <div className="flex flex-col gap-4">
        <p className="text-base font-bold">Send a patient invitation later.</p>
        <div className="mb-4">
          Inviting a patient to download the OneStep app can be done at any point from the patient's
          page. Simply click the 'Invite to App' button on the overview page
        </div>
        <img src={profileImage} className={styles.profileImg} />
      </div>
    </div>
  );
};

export default SkipSentSmsView;
